<template>
    <div
        class="info-page__container"
    >
        {{ $capitalize($t(message).toString()) }}
        <slot />
        <StaticLink
            :path="$WikiPath.Help"
            label="help"
        />
    </div>
</template>

<script>
    export default {
        name: 'InfoContainer',
        computed: {
            message() {
                if (!this.$router.currentRoute.params.message) {
                    return '';
                }

                return this.$router.currentRoute.params.message;
            },
        },
    };
</script>
